<template>
  <v-card class="main-card" :variant="'text'">
    <v-card-title
      class="screen-title"
      :class="{ 'mb-3': !$service.permission.isNormalUser() }"
    >
      <span>HOME</span>
      <div>
        <v-btn class="mr-2" color="primary" @click="contactUs"
          >お問い合わせ</v-btn
        >
        <manual-button path="/pre-top/" />
      </div>
    </v-card-title>
    <v-card-text class="pa-5" v-if="isLoaded">
      <v-row>
        <v-col>
          <!-- お知らせ情報 -->
          <div
            class="d-flex justify-space-between align-end"
            :class="{ 'mb-1': !$service.permission.isNormalUser() }"
          >
            <v-btn class="mb-1" color="primary" @click="load">一覧更新</v-btn>
            <div
              class="d-flex align-end ga-3"
              v-permission.normal
              :style="{
                visibility:
                  tabValue === 'maintenance' &&
                  maintenanceViewMode === 'calendar'
                    ? 'hidden'
                    : 'visible',
              }"
            >
              <v-checkbox
                hide-details
                v-model="isUnread"
                label="未読メッセージのみ表示"
                class="checkbox"
              ></v-checkbox>
              <span v-if="isListUnChecked" class="color-gray read-text"
                ><v-icon icon="$mdiFormatListBulleted" class="mr-1"></v-icon>
                既読にする
              </span>
              <a href="#" @click="selectedRead" v-else class="read-text"
                ><v-icon icon="$mdiFormatListBulleted" class="mr-1"></v-icon>
                既読にする
              </a>
            </div>
          </div>
          <v-tabs v-model="tabValue" grow hide-slider>
            <v-tab value="maintenance">
              <span class="mr-1">メンテナンス</span>
              <v-alert
                v-permission.normal
                v-if="maintenanceItemUnread > 0"
                class="badge"
                color="error"
                >{{ maintenanceItemUnread }}</v-alert
              >
            </v-tab>
            <v-tab value="failureNotification">
              <span class="mr-1">障害情報</span>
              <v-alert
                v-permission.normal
                v-if="failureNotificationItemUnread > 0"
                class="badge"
                color="error"
                >{{ failureNotificationItemUnread }}</v-alert
              >
            </v-tab>
            <v-tab value="notification">
              <span class="mr-1">その他お知らせ</span>
              <v-alert
                v-permission.normal
                v-if="notificationItemUnread > 0"
                class="badge"
                color="error"
                >{{ notificationItemUnread }}</v-alert
              >
            </v-tab>
          </v-tabs>
          <v-tabs-window
            v-model="tabValue"
            class="tab-card"
            :class="{
              'tab-card--list':
                maintenanceViewMode === 'list' && tabValue === 'maintenance',
              'tab-card--calendar':
                maintenanceViewMode === 'calendar' &&
                tabValue === 'maintenance',
            }"
          >
            <v-tabs-window-item value="maintenance">
              <app-calendar
                :selectable="selectable"
                :maintenance-items="maintenance.items"
                :is-unread="isUnread"
                @show-notification="showNotification"
                @view-mode-changed="handleViewModeChanged"
                @update:selected="handleMaintenanceSelectedUpdate"
              />
            </v-tabs-window-item>
            <v-tabs-window-item value="failureNotification">
              <app-table
                primary-key="noticeInfoSeq"
                :fields="failure_notification.fields"
                :items="failureNotificationItem"
                :selectable="true"
                v-model="failure_notification.selected"
                :hover="true"
                @click:row="showNotification"
                :tr-class="rowUnRead"
                :per-page="-1"
              >
                <template #cell(_selected)="data">
                  <v-checkbox-btn
                    v-if="selectable && !data.item.isRead"
                    :value="data.item"
                    v-model="failure_notification.selected"
                    @click.stop
                  />
                </template>
                <template #cell(postStartDateTime)="{ value }">
                  {{ $filter.date(value) }}
                </template>
              </app-table>
              <div
                v-if="failureNotificationItem.length === 0"
                class="text-center mt-5"
              >
                <span v-if="isUnread">現在未読の障害情報はありません</span>
                <span v-else>現在障害情報はありません</span>
              </div>
            </v-tabs-window-item>
            <v-tabs-window-item value="notification">
              <app-table
                primary-key="noticeInfoSeq"
                :fields="notification.fields"
                :items="notificationItem"
                :selectable="true"
                v-model="notification.selected"
                :hover="true"
                @click:row="showNotification"
                :tr-class="rowUnRead"
                :per-page="-1"
              >
                <template #cell(_selected)="data">
                  <v-checkbox-btn
                    v-if="selectable && !data.item.isRead"
                    :value="data.item"
                    v-model="notification.selected"
                    @click.stop
                  />
                </template>
                <template #cell(postStartDateTime)="{ value }">
                  {{ $filter.date(value) }}
                </template>
              </app-table>
              <div
                v-if="notificationItem.length === 0"
                class="text-center mt-5"
              >
                <span v-if="isUnread"
                  >現在未読のその他お知らせ情報はありません</span
                >
                <span v-else>現在その他お知らせ情報はありません</span>
              </div>
            </v-tabs-window-item>
          </v-tabs-window>

          <div class="mt-4">
            <h3 class="mb-2">トラフィック帯域超過機能ステータス一覧</h3>
            <app-search :search="status.search" v-model="status.filter" />
            <app-table
              primary-key="_primary"
              v-model:table-sort-by="status.sortBy"
              :sort-compare="statusTableSort"
              :sort-compare-key="['exceedThresholdDateTime']"
              :fields="status.fields"
              :items="status.items"
              :filter="status.filter"
              :filter-option="status.filter_option"
              :hover="true"
              @click:row="showTrafficStatus"
            >
              <template #cell(number)="{ value }">
                {{ $filter.emptyTo(value, "-") }}
              </template>
              <template #cell(exceedThresholdDateTime)="{ value }">
                {{ $filter.datetime(value) }}
              </template>
              <template #cell(restorationDateTime)="{ value }">
                {{ $filter.datetime(value) }}
              </template>
            </app-table>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { NoticeInfo } from "@/apis/InformationApi";
import { mapState } from "vuex";
import type { AlarmInfoEntity } from "@/apis/ThresholdSettingApi";
import type { SortCompareFunc } from "@/services/SortService";
import type {
  AppTableHeader,
  FilterOption,
  SortItem,
} from "@/components/AppTable.vue";
import NotificationReference from "@/modals/notificationReference/NotificationReference.vue";
import ContactUsReference from "@/modals/contactUs/ContactUsReference.vue";
import type { SearchOption } from "@/components/AppSearch.vue";
import AppCalendar from "@/components/maintenance/AppCalendar.vue";

export default defineComponent({
  name: "TopPage",
  components: {
    AppCalendar,
  },
  data() {
    return {
      tabValue: "maintenance",
      // その他お知らせ,
      notification: {
        fields: [
          { key: "postStartDateTime", title: "掲載日", width: "100px" },
          { key: "noticeInfoTitle", title: "件名" },
        ] as AppTableHeader<NoticeInfo>[],
        items: [] as NoticeInfo[],
        selected: [] as NoticeInfo[],
      },
      // 障害お知らせ,
      failure_notification: {
        fields: [
          { key: "postStartDateTime", title: "掲載日", width: "100px" },
          { key: "noticeInfoTitle", title: "件名" },
        ] as AppTableHeader<NoticeInfo>[],
        items: [] as NoticeInfo[],
        selected: [] as NoticeInfo[],
      },
      // メンテナンス,
      maintenance: {
        items: [] as NoticeInfo[],
        selected: [] as NoticeInfo[],
      },
      // トラフィック帯域超過機能ステータス一覧
      status: {
        sortBy: {
          key: "exceedThresholdDateTime",
          order: "desc",
        } as SortItem,
        fields: [
          {
            key: "number",
            title: "対象回線番号",
            width: "200px",
            filterByFormatted: true,
            formatter: (_v: string, _k: string, item: AlarmInfoEntity) => {
              // E番号またはW番号を表示
              if (item.enumber) {
                return item.enumber;
              } else {
                return item.wnumber;
              }
            },
          },
          {
            key: "direction",
            title: "方向",
            width: "100px",
            sortByFormatted: true,
            filterByFormatted: false,
            formatter: (v: AlarmInfoEntity["direction"]) => {
              return this.$filter.enumTo(v, "trafficThreshold_direction");
            },
          },
          {
            key: "exceedThresholdDateTime",
            title: "超過日時",
            width: "200px",
            sortable: true,
          },
          {
            key: "restorationDateTime",
            title: "復旧日時",
            width: "200px",
            sortable: true,
          },
          {
            key: "alarmType",
            title: "ステータス",
            width: "200px",
            sortable: true,
            sortByFormatted: true,
            filterByFormatted: false,
            formatter: (v: AlarmInfoEntity["alarmType"]) => {
              return this.$filter.enumTo(v, "trafficThreshold_alarmType");
            },
          },
        ],
        items: [] as AlarmInfoEntity[],
        search: {
          number: { type: "text", label: "対象回線番号" },
          direction: {
            type: "select",
            label: "方向",
            items: [
              { text: "送信", value: "SEND" },
              { text: "受信", value: "RECEIVE" },
            ],
          },
          alarmType: {
            type: "select",
            label: "ステータス",
            items: [
              { text: "超過", value: "EXCESS" },
              { text: "復旧", value: "RESTORATION" },
            ],
          },
        } as SearchOption,
        filter: {},
        filter_option: {
          number: "like",
          direction: "equal",
          alarmType: "equal",
        } as FilterOption,
      },

      isLoaded: false,
      // 未読
      isUnread: false,
      // メンテナンスの表示モード
      maintenanceViewMode: "list" as "calendar" | "list",
    };
  },
  computed: {
    ...mapState("user", {
      loginUser: "loginUser",
      contractSummary: "contractSummary",
    }),
    /**
     * トラフィック帯域超過機能ステータス一覧ソート.
     * 第1優先: 超過日時（降順）, 第2優先: ステータス（昇順）
     */
    statusTableSort(): SortCompareFunc<AlarmInfoEntity> {
      return this.$service.tableSortCompare(
        this.status.sortBy,
        "exceedThresholdDateTime",
        [
          (e: AlarmInfoEntity) =>
            this.$filter.enumTo(e.alarmType, "trafficThreshold_alarmType"),
          "asc",
        ]
      );
    },
    /**
     * ノーマルユーザーか否かを返却
     * それによりチェックボックスの表示切り替え
     */
    selectable(): boolean {
      return this.$service.permission.isNormalUser();
    },
    /**
     * 障害情報のitemを返却
     * 未読のみの表示の場合は、未読のみのitemを返却する。
     */
    failureNotificationItem(): NoticeInfo[] {
      if (this.isUnread) {
        return this.failure_notification.items.filter(
          (e) => e.isRead === false
        );
      }
      return this.failure_notification.items;
    },
    /**
     * その他お知らせのitemを返却
     * 未読のみの表示の場合は、未読のみのitemを返却する。
     */
    notificationItem(): NoticeInfo[] {
      if (this.isUnread) {
        return this.notification.items.filter((e) => e.isRead === false);
      }
      return this.notification.items;
    },
    /**
     * お知らせの既読ボタンの活性非活性を返却
     * Checkedが一つ以上で活性化
     */
    isListUnChecked(): boolean {
      return (
        this.maintenance.selected.length === 0 &&
        this.failure_notification.selected.length === 0 &&
        this.notification.selected.length === 0
      );
    },
    /**
     * 各タブの未読件数返却
     */
    maintenanceItemUnread(): number {
      return this.maintenance.items.filter((e) => e.isRead === false).length;
    },
    failureNotificationItemUnread(): number {
      return this.failure_notification.items.filter((e) => e.isRead === false)
        .length;
    },
    notificationItemUnread(): number {
      return this.notification.items.filter((e) => e.isRead === false).length;
    },
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  methods: {
    /** 読み込み */
    async load() {
      const notice = await this.$api.information.getNotifications();
      this.status.items = (await this.$api.thresholdSetting.getAlarmInfo()).map(
        // 選択を使用しないのでindexでも可
        (e: AlarmInfoEntity, i: number) => ({ ...e, _primary: i })
      );

      // 各タブの一覧
      this.notification.items = notice.filter((item: NoticeInfo) => {
        return item.noticeType === "NOTIFICATION";
      });
      this.failure_notification.items = notice.filter((item: NoticeInfo) => {
        return item.noticeType === "FAILURE_NOTIFICATION";
      });
      this.maintenance.items = notice.filter((item: NoticeInfo) => {
        return item.noticeType === "MAINTENANCE";
      });

      // 各タブのチェックボックスを初期化
      this.maintenance.selected.splice(0);
      this.failure_notification.selected.splice(0);
      this.notification.selected.splice(0);
    },
    /** お知らせ詳細表示 */
    async showNotification(entity: NoticeInfo) {
      if (
        entity.isRead === false &&
        !this.$service.permission.isDelegateUser()
      ) {
        await this.$api.information.putRead(entity.noticeInfoSeq);
        entity.isRead = true;
      }
      await this.$modal.show(NotificationReference, {
        noticeInfoSeq: entity.noticeInfoSeq,
        noticeType: entity.noticeType,
      });
    },
    /**
     * メンテナンス表示モードの変更ハンドラー
     */
    handleViewModeChanged(viewMode: "calendar" | "list") {
      this.maintenanceViewMode = viewMode;
    },
    /**
     * メンテナンスの選択状態の変更ハンドラー
     */
    handleMaintenanceSelectedUpdate(selected: NoticeInfo[]) {
      this.maintenance.selected = selected;
    },
    /**
     * お知らせ一覧未読レイアウト表示
     */
    rowUnRead(item: NoticeInfo): string[] | undefined {
      if (this.$service.permission.isDelegateUser()) {
        return ["clickable"];
      } else {
        if (item.isRead === false) {
          return ["clickable", "table-unread"];
        } else {
          return ["clickable", "table-read"];
        }
      }
    },
    /** トラフィック画面表示 */
    async showTrafficStatus(item: AlarmInfoEntity) {
      await this.$router.push({
        path: "/report",
        query: {
          lineType: item.lineType,
          enumber: item.enumber ? item.enumber : undefined,
          wnumber: item.wnumber ? item.wnumber : undefined,
        },
      });
    },
    /**
     * お知らせ一覧選択既読
     */
    async selectedRead() {
      const promisesMaintenance = this.maintenance.selected.map(
        async (e) => await this.$api.information.putRead(e.noticeInfoSeq)
      );

      const promiseFailure = this.failure_notification.selected.map(
        async (e) => await this.$api.information.putRead(e.noticeInfoSeq)
      );

      const promiseNotification = this.notification.selected.map(
        async (e) => await this.$api.information.putRead(e.noticeInfoSeq)
      );
      const promises = promisesMaintenance.concat(
        promiseFailure,
        promiseNotification
      );

      await Promise.all(promises);
      await this.load();
    },

    /** お問い合わせ画面表示 */
    async contactUs() {
      await this.$modal.show(ContactUsReference);
    },
  },
});
</script>

<style lang="scss" scoped>
:deep(table) {
  tr.table-unread {
    font-weight: bold;
    color: #000;
  }
  tr.table-read {
    color: gray;
  }
  td {
    white-space: pre;
  }
}

:deep(.checkbox) {
  .v-selection-control__input,
  .v-checkbox-btn,
  .v-label {
    display: flex;
    align-items: end;
  }
}

.inq {
  line-height: 2;
}

.color-gray {
  color: gray;
}

.read-text {
  display: flex;
  align-items: center;
}

.tab-card {
  height: 346px;
  overflow: hidden;
  margin-bottom: 20px;
  position: relative;
  &.tab-card--list {
    height: 394px; //上部のカレンダーとリストの切り替えボタンの高さを追加
  }
  &.tab-card--calendar {
    height: auto;
  }
}

.badge {
  border-radius: 10rem;
  line-height: 1;
  font-size: 12px;
  padding: 3px 6.164px;
}

// AppTableのヘッダーの左寄せ
:deep(.v-table) {
  .v-data-table-header__content {
    justify-content: flex-start !important;
  }
}
</style>
